import $http from '../../axios';
import {Notification} from "element-ui";


export async  function fetchExcelInvetory({ state },branch) {
    state.loading.module = true;
    await $http({
        url: '/api/excel-contable-inventario',
        params: state.params,
        method: 'GET',
        responseType: "blob",
    }).
    then(response => {
        state.loading.module = false;
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        let name = `${branch.name}-`
         switch (state.params.type_query){
             case '1':
                 name += 'Contabilidad-'
                 break;
             case '2':
                 name += 'Inventarios-'
                 break
             case '3':
                 name += 'Terceros-'
                 break
         }
        const fecha = new Date(state.params.year_month_up);

        const dia = String(fecha.getDate()).padStart(2, '0');
        const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses en Date son zero-based (0-11)
        const anio = fecha.getFullYear();

        name+= `.xlsx`

        console.log(name)
        link.setAttribute("download", name);
        document.body.appendChild(link);
        link.click();
    }).catch(error => {
        state.loading.module = false;
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}



// WEBPACK FOOTER //
// ./src/modules/excel-inventory/actions.js